import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { XCircle, Save } from "react-feather";
import { POST } from "../../../api/adminApi";
import { toast } from "react-toastify";

export default function SmsBulkCreate() {
  const history = useHistory();
  const [msg, setMsg] = useState("");
  const [phone, setPhone] = useState("");

  function handleMessageChange(e) {
    setMsg(e.target.value);
  }

  function handlePhoneChange(e) {
    setPhone(e.target.value);
  }

  function onSubmit(e) {
    e.preventDefault();

    if (!msg.trim()) {
      toast.error("Введите сообщение");
      return;
    }

    if (!phone.trim()) {
      toast.error("Введите номера телефонов");
      return;
    }

    const phonesArray = phone
      .split(/[\n,]+/)
      .map((p) => p.trim())
      .filter((p) => p);

    if (phonesArray.length === 0) {
      toast.error("Введите хотя бы один номер");
      return;
    }

    for (const p of phonesArray) {
      if (!/^\d+$/.test(p)) {
        toast.error(`Неверный формат: ${p} (только цифры)`);
        return;
      }
      if (!p.startsWith("998")) {
        toast.error(`Номер должен начинаться с 998: ${p}`);
        return;
      }
      if (p.length !== 12) {
        toast.error(`Неверная длина: ${p} (должно быть 12 цифр)`);
        return;
      }
    }

    async function create() {
      const response = await POST("/services/admin/api/bulk-sms", {
        message: msg,
        phones: phonesArray,
      });
      if (response?.success) {
        history.push("/admin/sms-bulk");
        toast.success("Успешно добавлен");
      }
    }
    create();
  }

  return (
    <div className="mb-1 mx-3 ">
      <h3 className="mb-5 mt-5 text-center">Создать CMC рассылки</h3>
      <form onSubmit={onSubmit} autoComplete="off">
        <div
          className="admin-card p-4 pt-12 d-flex flex-column justify-content-between"
          style={{ height: "70vh" }}
        >
          <div className="mb-1 d-flex">
            <div className="">
              {/* Phone Number Input */}
              <div className="d-flex align-items-center mb-2 gap-2">
                <label
                  style={{ width: "120px" }}
                  className="color-grey text-end text-nowrap"
                >
                  Номера телефонов
                </label>
                <div>
                  <textarea
                    name="phone"
                    rows={5}
                    value={phone}
                    onChange={handlePhoneChange}
                    className="input-control"
                    style={{ width: "300px" }}
                    placeholder="998... (через запятую или с новой строки)"
                  />
                </div>
              </div>

              {/* Message Input */}
              <div className="d-flex align-items-center mb-2 gap-2">
                <label
                  style={{ width: "120px" }}
                  className="color-grey text-end text-nowrap"
                >
                  Сообщение
                </label>
                <div>
                  <textarea
                    value={msg}
                    name="messageText"
                    type="text"
                    className="input-control"
                    onChange={handleMessageChange}
                    style={{ width: "300px" }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <Link to="/admin/sms-bulk" className="mr-3">
              <button className="btn text-white btn-bg-primary d-flex align-items-center">
                <XCircle size={14} className="mr-2" />
                Отмена
              </button>
            </Link>
            <button
              className="btn text-white btn-bg-success d-flex align-items-center"
              type="submit"
            >
              <Save size={14} className="mr-2" />
              Сохранить
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
